<template>
  <table>
    <thead>
      <tr>
        <th v-for="(header, index) in headers" :key="`column-${index}`">
          {{ header.label }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in data" :key="`row-${index}`">
        <td v-for="(column, idx) in row" :key="`column-${idx}`"
          v-if="
            !index
            || (
              data[index - 1][idx].key !== column.key
            )
          "
          :rowspan="column.rowspan"
          :class="{ 'text-xs-center': headers.length < 2, 'text-xs-right': headers.length > 1 && columns.filter(item => item.value === column.type).length }">
          <span v-if="column.type === 'total' || column.type === 'quantity'">
            {{ column.value || 'Sin información' }}
          </span>
          <span v-else-if="column.type === 'channel'">
            {{ getChannelField('channel', column.value, 'name') }}
          </span>
          <span v-else-if="column.type === 'status_type'">
            {{ statusTypeName(column.value) || 'Sin información' }}
          </span>
          <span v-else>
            {{ column | formatNumber(fields) }}
          </span>
        </td>
      </tr>
    </tbody>
    <tfoot v-if="fields.length">
      <tr>
        <td :colspan="headers.length - columns.length" class="text-xs-right">
          <strong>Total</strong>
        </td>
        <td 
          v-for="(total, index) in totals"
          :key="`table-footer-${index}`"
          class="text-xs-right">
            <span v-if="total.type === 'total' || total.type === 'quantity'">
              {{ total.value }}
            </span>
            <span v-else>
              {{ total | formatNumber(fields) }}
            </span>
        </td>
      </tr>
    </tfoot>
  </table>
  <!--
  <div :class="{ 'table-body': rowIndex === 0, 'table': rowIndex !== 0 }" class="px-0">
    <div v-for="(row, index) in data" :key="`row-${index}`" class="table-row bordered-bottom">
      <template v-if="fields[rowIndex]">
        <div :class="{ 'table-col': true }">
          <span>
            {{ row[fields[rowIndex].value] }}
          </span>
        </div>
         <pivot-table
          v-if="row.data.filter(item => item.hasOwnProperty('data')).length > 0"
          :data="row.data"
          :fields="fields"
          :columns="columns"
          :row-index="rowIndex + 1">
        </pivot-table>
        <template v-else>
          <div 
            v-for="(column, idx) in columns"
            class="table-col" :style="{ width: `calc(100vw / ${columnsCount})` }"
            :key="`column-${idx}`">
            <div v-for="(d, i) in row.data" :key="`item-list-${rowIndex}-${i}`" :class="{ 'text-xs-center': fields.length === 0, 'text-xs-right': fields.length > 0 }">
              <template v-if="column.value === 'total' || column.value === 'quantity'">
                {{ d[column.value] }}
              </template>
              <template v-else>
                {{ d[column.value] | formatNumber }}
              </template>
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="table-col" :style="{ width: `calc(100vw / ${columnsCount})` }" v-for="(column, idx) in columns" :key="`column-${idx}`">
          <div v-for="(d, i) in data" :key="`item-list-${rowIndex}-${i}`" :class="{ 'text-xs-center': fields.length === 0, 'text-xs-right': fields.length > 0 }">
            <template v-if="column.value === 'total' || column.value === 'quantity'">
              {{ d[column.value] }}
            </template>
            <template v-else>
              {{ d[column.value] | formatNumber }}
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
  -->
</template>

<script>
import ChannelMixin from '@/mixins/channels';
import PivotTable from './PivotTable';

export default {
  name: 'pivot-table',
  props: {
    rowIndex: {
      type: Number,
      default: 0,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    columnsCount: {
      type: Number,
      required: true,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    totals: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [
    ChannelMixin,
  ],
  components: {
    PivotTable,
  },
  filters: {
    formatNumber(column, fields) {
      const filter = fields.filter(item => item.value === column.type);
      if (filter.length) {
        return column.value;
      }
      return new Intl.NumberFormat('es-VE', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(column.value);
    },
  },
  data() {
    return {
    };
  },
  computed: {
    boxSize() {
      return Math.floor(12 / (this.columns.length + this.fields.length)) + this.rowIndex;
    },
  },
  methods: {
    statusTypeName(name) {
      const status = {
        not_reached: 'Sin contacto',
        not_sent: 'No enviado',
        pending: 'Pendiente',
        reached: 'Contactado',
        sent: 'Enviado',
      };
      return status[name];
    },
  },
};
</script>

<style scoped>
  .table {
    display: table;
    border-collapse: collapse;
  }
  .table-body {
    display: table;
    border-collapse: collapse;
  }
  .table-row {
    width: auto;
    clear: both;
    display: table-row;
  }
  .table-col {
    padding: 1em;
    display: table-cell;
    min-width: 150px;
    max-width: 150px;
    border-left: 1px solid #d3d3d3;
  }
  .bordered-bottom:not(:last-child) {
    border-bottom: 1px solid #d3d3d3;
  }
  .border-right {
    border-right: 1px solid #d3d3d3;
  }
  .break-word {
    word-break: break-all;
  }
  table {
    width: 100%;
    border-top: 1px solid #d3d3d3;
    border-left: 1px solid #d3d3d3;
    border-right: 1px solid #d3d3d3;
    border-radius: 4px;
  }
  table thead tr th:not(:last-child) {
    border-right: 1px solid #d3d3d3;
  }
  table thead tr th {
    padding: 1em;
    min-width: 150px;
    border-bottom: 1px solid #d3d3d3;
  }
  table > tbody {
    width: 100%;
    padding: 1em;
  }
  table td {
    padding: 1em;
    min-width: 150px;
    border-bottom: 1px solid #d3d3d3;
  }
  table td:not(:last-child) {
    padding: 1em;
    border-right: 1px solid #d3d3d3;
  }
</style>


// WEBPACK FOOTER //
// src/components/global/report_datatables/PivotTable.vue